<template>
    <el-date-picker v-bind="$attrs" v-on="$listeners" :format="format" :value-format="valueFormat" :value="value" @input="change"/>
</template>

<style lang="scss">
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        @apply w-full;
    }

    /*.custom-date-picker {
        &.el-date-editor {
            @apply w-full p-0 border-0;
            height: 38px;

            .el-input__inner {
                @apply h-full py-1 pl-8 pr-4 leading-normal rounded-none border border-grey-light;
                &:focus {
                    @apply border-black;
                }
            }

            &.el-input__inner {
                @apply h-full py-1 px-2 leading-normal rounded-none border border-grey-light;
                &:focus {
                    @apply border-black;
                }
            }

            &.is-active, &.is-active:hover {
                @apply border-grey-light;
            }

            .el-input__icon {
                line-height: normal;
            }
        }
    }

    .el-picker-panel.el-date-range-picker.el-popper.has-time {
        top: 263px;
    }

    .el-date-editor .el-range-separator {
        color: lightgray;
    }

    .el-input__inner {
        border-radius: 0;
    }

    .el-date-editor .el-range__icon {
        margin-left: 5px;
    }

    .el-picker-panel {
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 0;
    }*/
</style>

<script>
export default {
  props: {
    value: {},
    format: { type: String, default: 'dd-MM-yyyy' },
    valueFormat: { type: String, default: 'yyyy-MM-dd' }
  },
  methods: {
    change (value) {
      this.$emit('input', value)
    }
  }
}
</script>
